<script setup lang="ts">
import { reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSession } from '../stores/session'
import { useForm } from '../lib/form'
import UiCard from '../components/UiCard.vue'
import UiButton from '../components/UiButton.vue'
import UiField from '../components/UiField.vue'
import ErrorBanner from '../components/ErrorBanner.vue'

const route = useRoute()
const router = useRouter()
const session = useSession()
const { busy, error, submit, fieldErr } = useForm()
const redirect = typeof route.query.redirect === 'string' ? route.query.redirect : '/'
const form = reactive({ email: typeof route.query.email === 'string' ? route.query.email : '', password: '' })

async function onSubmit() {
  if (await submit(() => session.login(form.email, form.password))) router.replace(redirect)
}
</script>

<template>
  <UiCard :title="$t('auth.loginTitle')" :subtitle="$t('auth.loginSubtitle')">
    <form class="stack" @submit.prevent="onSubmit">
      <ErrorBanner :error="error" />
      <UiField :label="$t('fields.email')" :error="fieldErr('email')">
        <input v-model.trim="form.email" name="email" type="email" autocomplete="email" required :aria-invalid="!!fieldErr('email')" />
      </UiField>
      <UiField :label="$t('fields.password')" :error="fieldErr('password')">
        <input v-model="form.password" name="password" type="password" autocomplete="current-password" required :aria-invalid="!!fieldErr('password')" />
      </UiField>
      <UiButton type="submit" :loading="busy">{{ $t('auth.loginAction') }}</UiButton>
      <p class="small muted">
        {{ $t('auth.noAccount') }}
        <RouterLink :to="{ path: '/register', query: route.query }">{{ $t('auth.registerLink') }}</RouterLink>
      </p>
    </form>
  </UiCard>
</template>
